import {createAction, props} from "@ngrx/store";
import {TradeRoute} from "../../models/TradeRoute";


export const UPDATE = '[TradeRoutes] Update';
export const REFRESH = '[TradeRoutes] Init';
export const update = createAction(UPDATE, props<{ tradeRoutes: TradeRoute[] }>());
export const refresh = createAction(REFRESH);
